import { useQuery } from '@tanstack/react-query'
import { subscriptionApi } from '@/api/subscription'
import { useAuthStore } from '@/store/authStore'
import { useEffect } from 'react'

/**
 * Hook to load and cache subscription info (limits and usage)
 * Automatically updates authStore when data is loaded
 */
export function useSubscriptionInfo() {
  const user = useAuthStore((state) => state.user)
  const setSubscriptionInfo = useAuthStore((state) => state.setSubscriptionInfo)

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['subscription-info', user?.id],
    queryFn: () => subscriptionApi.getInfo(user!.id),
    enabled: !!user?.id,
    staleTime: 30 * 1000, // 30 seconds
  })

  // Update authStore when data is loaded
  useEffect(() => {
    if (data) {
      setSubscriptionInfo(data)
    }
  }, [data, setSubscriptionInfo])

  return {
    subscriptionInfo: data,
    isLoading,
    error,
    refetch,
  }
}
